import script from "./OrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderList.vue?vue&type=script&setup=true&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=07d47800&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07d47800"]])

export default __exports__